import { GatewayCategoryProhibitedRuleDto } from './category-post-response.dto';

const getRuleValues = (rule: GatewayCategoryProhibitedRuleDto) =>
  Array.isArray(rule.value) ? rule.value : [rule.value];

export const isCategoryFullyProhibited = (
  rules: GatewayCategoryProhibitedRuleDto[] | undefined
) =>
  !!rules?.some(
    (rule) => rule.type === 'ALL' && getRuleValues(rule).includes('*')
  );

export const isCategoryProhibitedForShippingMethod = (
  rules: GatewayCategoryProhibitedRuleDto[] | undefined
) => !!rules?.some((rule) => rule.type === 'SHIPPING_METHOD');

export const getCategoryProhibitedShippingMethods = (
  rules: GatewayCategoryProhibitedRuleDto[] | undefined
) =>
  Array.from(
    new Set(
      rules
        ?.filter((rule) => rule.type === 'SHIPPING_METHOD')
        .flatMap(getRuleValues) ?? []
    )
  );

export const isCategoryProhibitedForCountry = (
  rules: GatewayCategoryProhibitedRuleDto[] | undefined
) => !!rules?.some((rule) => rule.type === 'COUNTRY');

export const getCategoryProhibitedCountries = (
  rules: GatewayCategoryProhibitedRuleDto[] | undefined
) =>
  Array.from(
    new Set(
      rules?.filter((rule) => rule.type === 'COUNTRY').flatMap(getRuleValues) ??
        []
    )
  );
